"use client";

import { useTranslations } from "next-intl";

export interface RankBadgeProps {
  /** 1-based rank position. Per Figma 5462:51594 — w=54, h=48. */
  rank: number;
}

/**
 * Rank chip — Figma node 5462:51523/51542/51561/51580.
 * bg-bg-tertiary60 (rgba(85,93,101,0.6)), w=54 h=48, rounded-tr-sm rounded-br-sm.
 * Number Peyda Semi Bold 18, "رتبه" Peyda Medium 12.
 *
 * Number renders with Arabic digits (1-8) per PM directive 2026-05-06 — was
 * Persian (۱-۸) until then. Persian copy stays for the "رتبه" label.
 */
export const RankBadge: React.FC<RankBadgeProps> = ({ rank }) => {
  const t = useTranslations("dao");
  return (
    <div className="flex h-12 w-[54px] flex-col items-center justify-center gap-1 rounded-br-sm rounded-tr-sm bg-bg-tertiary/60 px-1 text-text-primary">
      <span className="text-lg font-semibold leading-[1.4]">{rank}</span>
      <span className="text-xs font-medium leading-[1.4]">
        {t("election.rank.label")}
      </span>
    </div>
  );
};
